import getPersonaFromHexCID from './getPersonaFromHexCID';
import getPersonaPhotoQueue from './getPersonaPhotoQueue';
import mapPersonaToPersonaViewState from './helpers/mapPersonaToPersonaViewState';
import PersonaControlViewState from '../store/schema/PersonaControlViewState';
import personaControlStore from '../store/Store';
import getPersonaControlKey from '../utils/getPersonaControlKey';
import { ObservableMap } from 'mobx';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { isFeatureEnabled } from 'owa-feature-flags';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { action, select } from 'satcheljs/lib/legacy';

export interface GetPersonaPhotoState {
    personaViewStates: ObservableMap<string, PersonaControlViewState>;
}

/**
 * Gets the persona photo
 * @param name of the persona
 * @param emailAddress email address of the persona
 * @param size the size of the persona
 * @param hexCID hex id for a persona
 */
export default select({
    personaViewStates: () => personaControlStore.viewStates,
})(
    action('getPersonaPhoto')(function getPersonaPhoto(
        name: string,
        emailAddress: string,
        personaId: string,
        size: PersonaSize,
        hexCID: string,
        mailboxType: string,
        state?: GetPersonaPhotoState
    ) {
        let personaKey = getPersonaControlKey(emailAddress, personaId, size, mailboxType, name);
        if (!state.personaViewStates.has(personaKey)) {
            state.personaViewStates.set(
                personaKey,
                mapPersonaToPersonaViewState(
                    name,
                    hexCID,
                    emailAddress,
                    personaId,
                    size,
                    mailboxType
                )
            );
        }

        let personaViewState = state.personaViewStates.get(personaKey);
        if (
            !(isFeatureEnabled('rp-imageApiConsumer') && isConsumer()) &&
            personaViewState.hexConsumerIdForUser
        ) {
            getPersonaFromHexCID(personaViewState);
        } else {
            getPersonaPhotoQueue.add({ name, emailAddress, personaId, size, mailboxType });
        }
    })
);
